import axios from "axios";

const API_BASE_URL = "https://dbskillsattendance.iilos.org/api";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  // timeout: 10000,
});

// ✅ Add token automatically
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export const getServerTimeApi = async () => {
  const response = await axiosInstance.get("/attendance/server-time");
  return response.data;
};

export default axiosInstance;